export const saveCurrentPage = (title, previousPage = null) => {
  if (!title) return;

  const current = {
    title,
    url: window.location.pathname + window.location.search,
  };

  const storedCurrent = JSON.parse(
    localStorage.getItem("currentPage") || "{}"
  );

  if (storedCurrent.url === current.url) return;

  if (previousPage?.title && previousPage?.slug) {
    localStorage.setItem(
      "previousPage",
      JSON.stringify({
        title: previousPage.title,
        url: `/${previousPage.slug}`,
      })
    );
  } else if (storedCurrent.url) {
    localStorage.setItem(
      "previousPage",
      JSON.stringify(storedCurrent)
    );
  }

  localStorage.setItem(
    "currentPage",
    JSON.stringify(current)
  );
};

export const getPreviousPage = () =>
  JSON.parse(localStorage.getItem("previousPage") || "{}");